import { AuthAttribute, pickRoleAttrs } from "@megaron/access-control";

import { NotificationType } from "./notifications";

export type NotificationPermission = {
  app: string;
  permissionName: string;
  targetAudienceAttributes: AuthAttribute[];
};

export const notificationPermissionMap: { [K in NotificationType]: NotificationPermission } = {
  codeGenerationOrderCreated: {
    app: "loyaltyAdmin",
    permissionName: "Zlecenie generowania kodów",
    targetAudienceAttributes: [],
  },
  crmInteractionMention: {
    app: "crm",
    permissionName: "Oznaczenie w interakcji w CRM",
    targetAudienceAttributes: pickRoleAttrs("crm.admin", "crm.supervisor", "crm.user"),
  },
  crmRegionAssigned: {
    app: "crm",
    permissionName: "Klient przypisany do Twojego regionu",
    targetAudienceAttributes: pickRoleAttrs("crm.admin", "crm.supervisor", "crm.user"),
  },
  crmOrderSuspended: {
    app: "crm",
    permissionName: "Zamówienie wstrzymane",
    targetAudienceAttributes: pickRoleAttrs("crm.admin", "crm.supervisor", "crm.user"),
  },
  invoiceThreadMention: {
    app: "invoices",
    permissionName: "Oznaczenie w komentarzu wątku faktury",
    targetAudienceAttributes: ["userType:megarax"],
  },
  testWebPush: {
    app: "external",
    permissionName: "Testowe powiadomienie",
    targetAudienceAttributes: ["userType:megarax"],
  },
  taxReimbursementIssued: {
    app: "external",
    permissionName: "Zwrot podatku został wydany",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  productCodeRedemptionsGranted: {
    app: "loyalty",
    permissionName: "Punky za kody produktowe zostały przyznane",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  referralBonusEarned: {
    app: "loyalty",
    permissionName: "Otrzymano bonus za polecenie",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  affiliateCodeRedeemed: {
    app: "loyalty",
    permissionName: "Kod zaproszeniowy został wykorzystany",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  test: {
    app: "external",
    permissionName: "Testowe powiadomienie",
    targetAudienceAttributes: [],
  },
  testWithoutEmailTemplate: {
    app: "external",
    permissionName: "Testowe powiadomienie bez szablonu mailowego",
    targetAudienceAttributes: [],
  },
  loyaltyAdminOrderCreated: {
    app: "loyaltyAdmin",
    permissionName: "Złożone zamówienie",
    targetAudienceAttributes: pickRoleAttrs("fulfillment.packing-user"),
  },
  affiliateCodeAssigned: {
    app: "loyalty",
    permissionName: "Kod zaproszeniowy został przyznany",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  posOrderPromisedDeliveryDateSet: {
    app: "crm",
    permissionName: "Potwierdzenie zamówienia",
    targetAudienceAttributes: [],
  },
  cartInactive: {
    app: "loyalty",
    permissionName: "Koszyk nieaktywny przez 2 tygodnie",
    targetAudienceAttributes: [],
  },
  cartAutoArchived: {
    app: "loyalty",
    permissionName: "Koszyk został automatycznie zarchiwizowany",
    targetAudienceAttributes: [],
  },
  cartRewardCancelled: {
    app: "loyalty",
    permissionName: "Nagroda w koszyku została anulowana",
    targetAudienceAttributes: [],
  },
  blikCheckCashed: {
    app: "loyalty",
    permissionName: "Czek BLIK został zrealizowany",
    targetAudienceAttributes: [],
  },
  emailVerification: {
    app: "loyalty",
    permissionName: "Weryfikacja adresu email",
    targetAudienceAttributes: [],
  },
  loyaltyWelcome: {
    app: "loyalty",
    permissionName: "Wiadomość powitalna po weryfikacji e-mail",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  supportTicketAssigned: {
    app: "crm",
    permissionName: "Zgłoszenie przypisane do Ciebie",
    targetAudienceAttributes: pickRoleAttrs("support.user", "support.status-manager", "support.admin", "crm.user"),
  },
  supportTicketNewMessage: {
    app: "crm",
    permissionName: "Nowa wiadomość e-mail w przypisanym zgłoszeniu",
    targetAudienceAttributes: pickRoleAttrs("support.user", "support.status-manager", "support.admin", "crm.user"),
  },
};
